module.exports = __webpack_public_path__ + "static/media/slide-footer.c51acc34.jpg";